import GA from 'react-ga4';

const Tracker = {
  click: (label: string, value?: number, category?: string) => {
    const event = {
      action: 'click',
      value: value,
      category: category || String(window.localStorage.getItem('platform')), // twitter, youtube, or null
      label
    };
    window.localStorage.setItem(
      'preLogInfo',
      JSON.stringify({ time: Date.now(), event })
    );
    GA.event(event);

    //解决埋点延迟发送，导致点击切换页面时，上个页面的埋点不发送问题
    setTimeout(() => {
      window.localStorage.setItem('preLogInfo', 'false');
    }, 8000);
  },
  gtag: (operation: any, event: string, params: any) => {
    try {
      GA.gtag(operation, event, params);
    } catch (error) {
      // 静默失败，不影响主流程
      // console.warn('GA tracking error:', error);
    }
  },
  send: GA.send
}

//补发送 上一个页面没来的及发送的log
export const cleanPrePageLogInfo = () => {
  window.onload = () => {
    let preLogInfo = window.localStorage.getItem('advisterPreInfo');

    if (preLogInfo && preLogInfo !== 'false') {
      try {
        const { time, event } = JSON.parse(preLogInfo);
        if (Date.now() - time < 8000) {
          GA.event(event);
          window.localStorage.setItem('advisterPreInfo', 'false');
        }
      } catch (err) {
        console.error(err);
      }
    }
  };
};

export default Tracker;

declare global {
  interface Window {
    ahaTracker?: {
      payload?: {
        source?: string;
        orderId?: string;
      };
      track?: (events: Array<{
        name: string;
        value: number;
        currency?: string;
        transactionId: string;
      }>) => void;
    };
    twq?: ((...args: any[]) => void) | {
      (...args: any[]): void;
      queue?: any[][];
      version?: string;
      exe?: (...args: any[]) => void;
    };
  }
}

export const purchaseBuryingPoint = ({ price, unit, transactionId }: { price: number; unit?: string, transactionId: string }) => {
  try {
    if (window.ahaTracker?.payload?.source === 'Aha' && typeof window.ahaTracker?.track === 'function') {
      window.ahaTracker?.track([
        {
          name: "purchase",
          value: price,
          currency: unit ? unit : "",
          transactionId: transactionId
        }
      ]);
    }
  } catch (error) {
    console.error("AhaCreator Tracker error:", error);
  }
};

/**
 * Twitter 转化追踪埋点函数
 * @param eventId - Twitter 事件 ID，例如 'tw-papr0-quo3u'
 * @param params - 可选的事件参数对象
 */
export const trackTwitterEvent = (eventId: string, params?: Record<string, any>) => {
  try {
    if (typeof window !== 'undefined' && typeof (window as any).twq === 'function') {
      (window as any).twq('event', eventId, params || {});
    }
  } catch (error) {
    // 静默失败，不影响主流程
  }
};